import { HeadlessForm } from '@universal-ember/form';

<template>
  <HeadlessForm as |form|>
    <form.Field @name="name" as |field|>
      <div class="my-2 flex flex-col">
        <field.Label>Name</field.Label>
        <field.Input required minlength="3" class="border rounded px-2" />
        <field.Errors />
      </div>
    </form.Field>

    <form.Field @name="email" as |field|>
      <div class="my-2 flex flex-col">
        <field.Label>Email</field.Label>
        <field.Input @type="email" required class="border rounded px-2" />
        <field.Errors />
      </div>
    </form.Field>

    <form.Field @name="gender" as |field|>
      <field.RadioGroup class="my-2 flex flex-col" as |group|>
        <group.Label>Gender</group.Label>

        <div class="flex flex-row space-x-2">
          <group.Radio @value="male" as |radio|>
            <radio.Input required />
            <radio.Label>Male</radio.Label>
          </group.Radio>
          <group.Radio @value="female" as |radio|>
            <radio.Input required />
            <radio.Label>Female</radio.Label>
          </group.Radio>
          <group.Radio @value="other" as |radio|>
            <radio.Input required />
            <radio.Label>Other</radio.Label>
          </group.Radio>
        </div>
      </field.RadioGroup>
      <field.Errors />
    </form.Field>

    <button type="submit">Submit</button>
  </HeadlessForm>
</template>